import { Injectable } from '@angular/core';

@Injectable()
export class SideMenuService {
  sidenav: any;
  drawerContainer: any;
}



// WEBPACK FOOTER //
// ./src/app/system/core/side-menu/side-menu.service.ts